import type {ReactElement} from 'react';
import React from 'react';
import {Text, TextSize} from '@Components/text';
import styles from './download-quality-option.module.scss';
import {QualityItem} from '@Components/download-panel/components/quality-item/quality-item';
import {DesignQualityType} from '@Components/download-panel/components/quality-item/quality-item.types';

export function DownloadQualityOption(): ReactElement {
  return (
    <div className={`flex flex-v-row ${styles.container}`}>
      <Text bold size={TextSize.XSMALL} val={window.i18next.t('pmwjs_quality')} />
      <div className={`flex-h-row ${styles.gap}`}>
        <QualityItem
          id={DesignQualityType.BASIC}
          onClick={(): void => {}}
          text={window.i18next.t('pmwjs_basic_poster_download')}
          tagText={window.i18next.t('pmwjs_free')}
          isSelected
        />
        <QualityItem id={DesignQualityType.HIGH} onClick={(): void => {}} text={window.i18next.t('pmwjs_high')} tagText={'$4.49'} type={DesignQualityType.HIGH} />
      </div>
    </div>
  );
}
